import React, { useEffect, useState } from "react";
import { Grid, Button, Card} from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import BuscadorAbm from "../../../compartidos/abms/BuscadorAbm";
import { bajaPrestadorRestringido, buscarPrestadoresRestringidos, fetchPrestadoresRestringidos, modificarPrestadorRestringido, nuevoPrestadorRestringido } from "../../../../actions/autorizaciones/abmPrestadoresRestringidos";
import TableGeneric from "../../../compartidos/abms/TableGeneric";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { FormIngresoPrestadoresRestringidos } from "./FormIngresoPrestadoresRestringidos";
import {  TIPOS_DOCUMENTACION_PRACTICA_SOLICITUD } from "../../../../utils/permisos";
import ModalAbm from "../../../compartidos/abms/ModalAbm";
import AccionesGenericoAbm from "../../../compartidos/abms/AccionesGenericoAbm";
import { FormModifPrestadoresRestringidos } from "./FormModifPrestadoresRestringidos";


const useStyles = makeStyles({
  botonera: {
    padding: 25
  }
});

export const AbmPrestadoresRestringidosHome = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { items } = useSelector((state) => state.prestadoresRestringidos);

  const [open, setOpen] = useState(false);
  const [itemForm, setItemForm] = useState(false);
  // const [openModalInfo, setOpenModalInfo] = useState(false);
  // const [idClave, setIdClave] = useState(false);
  // const [descripcion, setDescripcion] = useState(false);

  const [openAlta, setOpenAlta] = useState(false);

  useEffect(() => {
    dispatch(fetchPrestadoresRestringidos());
  }, [dispatch]);

  const handleSearch = (textoBuscado) => {
    dispatch(buscarPrestadoresRestringidos(textoBuscado));
  }

  const cerrarModalAlta = () => setOpenAlta(false)

  const cerrarModalModif = () => setOpen(false)

  const handleItemSelect = (item) => {
    setItemForm(item)
    setOpen(true)
  }


  const handleSave = (item, value) => {
    
    const data = {
      id: item?.id,
      idEfectorFacturacion: value?.idEfectorFacturacion,
      observacion: item.observaciones
    }
    if (item.id){
      dispatch(modificarPrestadorRestringido(data))
      cerrarModalModif();
    }
    else {
      dispatch(nuevoPrestadorRestringido(data))
      cerrarModalAlta();
    }
  
  }

  const intialValue = {
    id: null,
    idEfectorFacturacion: null,
    razonSocial: null,
    observaciones: null,
    idUsuarioBaja: null,
    fechaBaja: null
  }

  const handleDelete = (item) => {
    const data = {
      id: item.id
    }
    dispatch(bajaPrestadorRestringido(data))
  }



  return (
    <div>
      {/* {openModalInfo && (
        <TrackingCosegurosExternos
          open={openModalInfo}
          onClose={() => setOpenModalInfo(false)}
          idClave={idClave}
          descripcion={descripcion}
          //tipoTrackingId={TIPO_TRACKING_ABM.GRUPO_COSEGURO}
          showCampo={true}
        />
      )} */}
      <Grid container justify="center">
        <ModalAbm title="Agregar Prestador" open={openAlta} setOpen={setOpenAlta}>
          <FormIngresoPrestadoresRestringidos formData={intialValue} handleSave={handleSave} cerrarModal={() => setOpenAlta(false)} permisoAlta={TIPOS_DOCUMENTACION_PRACTICA_SOLICITUD.ALTA} editando={false} />
        </ModalAbm>
        <ModalAbm title="Modificar" open={open} setOpen={setOpen}>
          <FormModifPrestadoresRestringidos formData={itemForm} handleSave={handleSave} cerrarModal={() => setOpen(false)} permisoEdit={TIPOS_DOCUMENTACION_PRACTICA_SOLICITUD.MODIFICACION} editando={true} />
        </ModalAbm>
        <Grid item xs={12}>
          <Button variant="contained" color="primary" onClick={() => setOpenAlta(true)} style={{ float: "right", marginTop: "1rem" }}>+ Agregar Prestador</Button>
        </Grid>
        <Grid item xs={12} md={6} className={classes.root}>
          <BuscadorAbm title="Buscar ingreso" handleSearch={handleSearch} />
        </Grid>
        <Grid item xs={12} md={9} style={{ marginTop: "2rem" }} >
          <Card>
            <TableGeneric
              data={items}
              columns={[
                {
                  label: "",
                  customBody: (item) => ((item.fechaBaja === null) &&
                    <AccionesGenericoAbm
                      item={item}
                      handleItemSelect={handleItemSelect}
                      permisoDelete={TIPOS_DOCUMENTACION_PRACTICA_SOLICITUD.BAJA}
                      handleDelete={handleDelete}
                     
                    />
                  )
                },
                {
                  label: "Id Efector Facturacion",
                  id: "idEfectorFacturacion",
                  sort: true
                },
                {
                  label: "Razon Social",
                  id: "razonSocial",
                  sort: true
                },
                {
                  label: "Observaciones",
                  id: "observaciones",
                  sort: true
                },
                {
                  label: "Fecha Baja",
                  id: "fechaBaja",
                  sort: true,
                  customBody: (item) => item.fechaBaja ? moment(item.fechaBaja).format('DD/MM/YYYY') : ""
                },
              ]}
            />
          </Card>
        </Grid>
      </Grid>
    </div>
  )
}
